import React from 'react';
import {useDispatch} from 'react-redux';

import {InlineNotification} from '@/components/ui/InlineNotification';
import {
    AUTO_DELIVERY_INACTIVE_DESCRIPTION,
    AUTO_DELIVERY_INACTIVE_TITLE,
    AUTO_DELIVERY_LEARN_MORE_LINK,
    AUTO_DELIVERY_LEARN_MORE_LINK_ARIA_LABEL,
} from '@/consts/localization/localizationKeys';
import {getLocalizedStrings} from '@/services/localization/localizationService';
import {showAutoDeliveryStatusInactiveDetailsPopup} from '@/state/slices/modalSlice';
import AutoDeliveryInactiveButton from '@/views/AutoDelivery/AutoDeliveryInactive/AutoDeliveryInactiveButton';

import AutoDeliveryWidgetContainer from '../components/AutoDeliveryWidgetContainer';
import AutoDeliveryWidgetHeader from '../components/AutoDeliveryWidgetHeader';
import AutoDeliveryStatusInactiveBenefits from './AutoDeliveryStatusInactiveBenefits';

const AutoDeliveryStatusInactive = ({className}) => {
    const dispatch = useDispatch();
    const localizedStrings = getLocalizedStrings();
    const redirect = () => dispatch(showAutoDeliveryStatusInactiveDetailsPopup());

    return (
        <AutoDeliveryWidgetContainer className={className}>
            <AutoDeliveryWidgetHeader
                btnLocalizationKey={AUTO_DELIVERY_LEARN_MORE_LINK}
                btnAriaLabelKey={AUTO_DELIVERY_LEARN_MORE_LINK_ARIA_LABEL}
                redirect={redirect}
            />
            <AutoDeliveryWidgetContainer.ContentContainer className='@container/inline-notification '>
                <InlineNotification
                    title={localizedStrings[AUTO_DELIVERY_INACTIVE_TITLE]}
                    body={localizedStrings[AUTO_DELIVERY_INACTIVE_DESCRIPTION]}
                >
                    <AutoDeliveryInactiveButton
                        primary
                        light
                        className='mt-0 self-start @2xl/inline-notification:w-auto'
                    />
                </InlineNotification>
                <AutoDeliveryStatusInactiveBenefits className='mt-4 md:mt-8' />
            </AutoDeliveryWidgetContainer.ContentContainer>
        </AutoDeliveryWidgetContainer>
    );
};

export default AutoDeliveryStatusInactive;
